// modalHelper.js

import { Modal } from 'bootstrap';

// Function to open a modal
export function openModal(modalId) {
  const modalElement = document.getElementById(modalId);
  if (modalElement) {
    const modalInstance = new Modal(modalElement);
    modalInstance.show();
  } else {
    console.error(`No modal found with ID ${modalId}`);
  }
}

// Function to close a modal
export function closeModal(modalId) {
  const modalElement = document.getElementById(modalId);
  if (modalElement) {
    const modalInstance = Modal.getInstance(modalElement);
    if (modalInstance) {
      modalInstance.hide();
    } else {
      console.error(`No instance found for modal with ID ${modalId}`);
    }
  } else {
    console.error(`No modal found with ID ${modalId}`);
  }
}